export default __webpack_public_path__ + "static/swatches_w.9a213231b3c86a00ecc829b037ae623e.svg";